/* External */
import {
  createContext,
  memo,
  useContext,
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';

/* Utils */
import platform from '../../utils/platform';

const DeviceInfoContext = createContext({});

export function useDeviceInfo() {
  return useContext(DeviceInfoContext);
}

function DeviceInfoProvider({ children }) {
  const [deviceInfo, setDeviceInfo] = useState({});

  useEffect(() => {
    async function awaitGetDeviceInfo() {
      try {
        const newDeviceInfo = await platform.getDeviceInfo();
        if (newDeviceInfo) {
          setDeviceInfo(newDeviceInfo);
        }
      } catch (error) {
        console.error('DeviceInfoProvider>awaitGetDeviceInfo error', error);
      }
    }
    awaitGetDeviceInfo();
  }, []);

  return (
    <DeviceInfoContext.Provider value={deviceInfo}>
      {children}
    </DeviceInfoContext.Provider>
  );
}

DeviceInfoProvider.propTypes = {
  children: PropTypes.node,
};

export default memo(DeviceInfoProvider);
